import { EnviromentalTag } from "../../../pages/forms/enviromentalTag"

const enviromentalTagRoutes = [
    {
        path: '/enviromentalTag',
        exact: true,
        layout: 'BlankLayout',
        component: () => <EnviromentalTag />,
        meta: {
            publicRoute: true,
        }
    }
]

export default enviromentalTagRoutes